/* Luca, 2026-09-19. Two bugs from a real customer journey:

   1. Filter New In by Cherry -> tap a product shown in Cherry -> the PDP opens
      with "COLOUR: Cherry" selected and the swatch ringed, but the gallery is
      still on slide 1, which is the Ink shot. She sees black. The gallery only
      moved when a swatch was clicked, never when a variant arrived
      pre-selected in the URL.

   2. Some collection cards rendered blank. Swapping src/srcset on a
      loading="lazy" image after the browser has run its lazy pass leaves it
      with currentSrc empty and it never fetches at all.

   Lives in its own asset rather than a new section, because a newly created
   section does not render until the theme is republished. */
(function(){
  function selectedVariantId(){
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form.sa-pdp__form [name="id"]');
    return input ? input.value : null;
  }

  var syncTries = 0;
  function syncGallery(){
    var data = document.querySelector('script[data-sa-pdp-variants]');
    var track = document.querySelector('.sa-pdp__media');
    if (!data || !track || track.dataset.saSynced) return;

    var id = selectedVariantId();
    if (!id) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch(e){ return; }

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
    }
    if (!v || !v.media) return;

    var slide = track.querySelector('[data-media-id="' + v.media + '"]');
    if (!slide) return;

    var target = slide.offsetLeft - track.offsetLeft;
    if (target <= 0) { markIfSettled(track, target); return; }

    /* scrollLeft on its own is swallowed by scroll-snap: x mandatory.
       scrollTo with an explicit instant behaviour lands and sticks. */
    track.scrollTo({ left: target, behavior: 'instant' });
    markIfSettled(track, target);
  }

  function markIfSettled(track, target){
    /* Only stop retrying once it actually landed: images finish loading after
       first paint and shift the offsets, so an early pass can miss. */
    if (Math.abs(track.scrollLeft - target) < 40) {
      track.dataset.saSynced = '1';
    } else if (++syncTries > 25) {
      track.dataset.saSynced = '1';
    }
  }

  function kickStalledImages(){
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) continue;
      if (img.currentSrc) continue;
      var box = img.getBoundingClientRect();
      if (box.width === 0 && box.height === 0) continue;
      /* Only what is on screen or just below, so we don't force the whole grid. */
      if (box.bottom < -300 || box.top > window.innerHeight + 600) continue;

      var src = img.getAttribute('src');
      if (!src) continue;
      var srcset = img.getAttribute('srcset');
      img.setAttribute('loading', 'eager');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    }
  }

  function run(){ try { syncGallery(); kickStalledImages(); } catch(e){} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  /* Images settle late, so re-check for a short while after load. */
  [120, 350, 700, 1200, 2000].forEach(function(ms){ setTimeout(run, ms); });
  window.addEventListener('scroll', kickStalledImages, { passive: true });
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();